"use strict";

var _interopRequireDefault = require("E:/WebProject/\u684C\u9762/JY-SSO/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addActionRequest = addActionRequest;
exports.addMenuRequest = addMenuRequest;
exports.deleteActionRequest = deleteActionRequest;
exports.deleteMenuRequest = deleteMenuRequest;
exports.getControllerList = getControllerList;
exports.getMenuDetail = getMenuDetail;
exports.getMenuList = getMenuList;
exports.updateActionRequest = updateActionRequest;
exports.updateMenuRequest = updateMenuRequest;
var _request = _interopRequireDefault(require("@/utils/request"));
function getMenuList(data) {
  return (0, _request.default)({
    url: '/api/v1/menu/list/all',
    method: 'get',
    params: data
  });
}
function getMenuDetail(id) {
  return (0, _request.default)({
    url: '/api/v1/menu/' + id,
    method: 'get'
  });
}
function addMenuRequest(data) {
  return (0, _request.default)({
    url: '/api/v1/menu',
    method: 'post',
    data: data
  });
}
function updateMenuRequest(data) {
  return (0, _request.default)({
    url: '/api/v1/menu/' + data.id,
    method: 'patch',
    data: data
  });
}
function addActionRequest(data) {
  return (0, _request.default)({
    url: '/api/v1/menu_action',
    method: 'post',
    data: data
  });
}
function updateActionRequest(data) {
  return (0, _request.default)({
    url: '/api/v1/menu_action/' + data.id,
    method: 'patch',
    data: data
  });
}
function deleteMenuRequest(id) {
  return (0, _request.default)({
    url: '/api/v1/menu/' + id,
    method: 'delete'
  });
}
function deleteActionRequest(id) {
  return (0, _request.default)({
    url: '/api/v1/menu_action/' + id,
    method: 'delete'
  });
}
function getControllerList(data) {
  return (0, _request.default)({
    url: '/api/v1/menu_action/controller/select',
    method: 'get',
    params: data
  });
}